import { render, staticRenderFns } from "./InformationDeviceWidgetComponent.vue?vue&type=template&id=12b8830f&"
import script from "./InformationDeviceWidgetComponent.vue?vue&type=script&lang=js&"
export * from "./InformationDeviceWidgetComponent.vue?vue&type=script&lang=js&"
import style0 from "./InformationDeviceWidgetComponent.vue?vue&type=style&index=0&id=12b8830f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports